import { render, staticRenderFns } from "./ProfessionalModalHeader.vue?vue&type=template&id=89c3c6ae"
import script from "./ProfessionalModalHeader.vue?vue&type=script&lang=js"
export * from "./ProfessionalModalHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports